<template>
  <div v-if="icpLicense || publicSecurityRecord" class="apoc-record-bar">
    <div class="apoc-record-bar__items">
      <a
        v-if="icpLicense"
        class="apoc-record-bar__link"
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ icpLicense }}
      </a>
      <a
        v-if="publicSecurityRecord"
        class="apoc-record-bar__link"
        href="https://www.beian.gov.cn/portal/registerSystemInfo"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ publicSecurityRecord }}
      </a>
    </div>
  </div>
</template>

<script>
import { ensureSiteConfig, siteConfigState } from '@/store/site-config'

export default {
  name: 'ApocRecordBar',
  computed: {
    icpLicense () {
      return siteConfigState.icpLicense
    },
    publicSecurityRecord () {
      return siteConfigState.publicSecurityRecord
    }
  },
  created () {
    ensureSiteConfig()
  }
}
</script>

<style scoped>
.apoc-record-bar {
  position: relative;
  z-index: 2;
  width: 100%;
  box-sizing: border-box;
  margin-top: 36px;
  padding: 22px 16px;
  border-radius: 0;
  background: rgba(5, 5, 5, .72);
  border: 0;
  box-shadow: none;
  color: #777267;
  font-size: 12px;
  line-height: 1.4;
  backdrop-filter: blur(6px);
}

.apoc-record-bar__items {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
}

.apoc-record-bar__link {
  color: inherit;
  text-decoration: none;
}

.apoc-record-bar__link:hover {
  color: #7fc9ff;
  text-decoration: underline;
}
</style>
